import React from 'react';
import { MeasureDisplayFormatKind } from '../../../utils/apollo/graphqlSchema';
import { SingleSelectMenu } from '../../Dropdown';
import * as MeasureDisplayFormatUI from './MeasureDisplayFormatUI';
import { getMeasureDisplayFormatKindLabel } from '../../../utils/builder/measures/measureDisplayFormat/utils';

interface IProps {
  value: MeasureDisplayFormatKind | null;
  onChange: (value: MeasureDisplayFormatKind) => void;
  placeholder?: string;
}

const options: MeasureDisplayFormatKind[] = [
  MeasureDisplayFormatKind.Number,
  MeasureDisplayFormatKind.Percent,
  MeasureDisplayFormatKind.Currency,
];

const MeasureDisplayFormatKindField = ({
  value,
  onChange,
  placeholder,
}: IProps) => {
  return (
    <MeasureDisplayFormatUI.FormRow>
      <MeasureDisplayFormatUI.FormLabel>
        Format
      </MeasureDisplayFormatUI.FormLabel>
      <SingleSelectMenu
        value={value || ''}
        onChange={(value) => onChange(value as MeasureDisplayFormatKind)}
        options={options.map((option) => ({
          value: option,
          text: getMeasureDisplayFormatKindLabel(option),
        }))}
        placeholder={placeholder}
      />
    </MeasureDisplayFormatUI.FormRow>
  );
};

export default MeasureDisplayFormatKindField;
